module.exports = __webpack_public_path__ + "img/banner-page-visit-ab.ac17b950.png";